
"use strict";

// =====================================================
// INICIO DE SESIÓN
//
// Archivo:
// src/fronend/seguridad/inicioSesion/inicio.js
//
// PROCEDIMIENTOS:
//
// 1. SP_INICIOSESIONADMIN
//    ROL = ADMINISTRADOR
//
// 2. SP_INICIOSESIONUSUARIONORMAL
//    ROL = RRHH
//
// 3. SP_INICIOSESIONOTROSUSUARIOS
//    ROLES:
//    - FINANZAS
//    - PRODUCCION
//    - LOGISTICA
//    - MERCADEO
//
// TODOS LOS ROLES:
// /menu.html
//
// =====================================================


// =====================================================
// ELEMENTOS DEL DOM
// =====================================================

const formInicioSesion =
    document.getElementById("formInicioSesion");

const usuario =
    document.getElementById("usuario");

const password =
    document.getElementById("password");

const mostrarPassword =
    document.getElementById("mostrarPassword");

const iconoPassword =
    document.getElementById("iconoPassword");

const btnIniciarSesion =
    document.getElementById("btnIniciarSesion");


// =====================================================
// COMPROBAR CARGA
// =====================================================

console.log(
    "INICIO.JS CARGADO CORRECTAMENTE"
);


// =====================================================
// MOSTRAR / OCULTAR CONTRASEÑA
// =====================================================

if (
    mostrarPassword &&
    password &&
    iconoPassword
) {

    mostrarPassword.addEventListener(
        "click",
        function () {

            if (
                password.type === "password"
            ) {

                password.type = "text";

                iconoPassword.classList.remove(
                    "bi-eye"
                );

                iconoPassword.classList.add(
                    "bi-eye-slash"
                );

            }

            else {

                password.type = "password";

                iconoPassword.classList.remove(
                    "bi-eye-slash"
                );

                iconoPassword.classList.add(
                    "bi-eye"
                );

            }

        }
    );

}


// =====================================================
// INICIAR SESIÓN
// =====================================================

async function iniciarSesion() {

    console.log(
        "INICIANDO SESIÓN"
    );


    // =================================================
    // OBTENER DATOS
    // =================================================

    const nombreUsuario =
        usuario.value.trim();

    const contrasenia =
        password.value.trim();


    // =================================================
    // VALIDAR
    // =================================================

    if (
        !nombreUsuario ||
        !contrasenia
    ) {

        alert(
            "Debe ingresar el usuario y la contraseña."
        );

        return;

    }


    // =================================================
    // DESHABILITAR BOTÓN
    // =================================================

    btnIniciarSesion.disabled =
        true;

    btnIniciarSesion.innerHTML =
        '<span class="spinner-border spinner-border-sm me-2"></span>' +
        'Validando...';


    try {


        // =================================================
        // =================================================
        // PRIMERA VALIDACIÓN
        //
        // ADMINISTRADOR
        //
        // Ruta:
        // /inicio/iniciarSesion
        //
        // Procedimiento:
        // SP_INICIOSESIONADMIN
        //
        // Rol:
        // ADMINISTRADOR
        //
        // =================================================
        // =================================================

        console.log(
            "VALIDANDO USUARIO ADMINISTRADOR..."
        );


        const respuestaAdmin =
            await fetch(
                "/inicio/iniciarSesion",
                {

                    method: "POST",

                    headers: {

                        "Content-Type":
                            "application/json",

                        "Accept":
                            "application/json"

                    },

                    body:
                        JSON.stringify({

                            NOMBRE_USUARIO:
                                nombreUsuario,

                            PASSWORD:
                                contrasenia

                        })

                }
            );


        console.log(
            "ESTADO HTTP ADMINISTRADOR:",
            respuestaAdmin.status
        );


        // =================================================
        // LEER RESPUESTA ADMINISTRADOR
        // =================================================

        const dataAdmin =
            await respuestaAdmin.json();


        console.log(
            "RESPUESTA ADMINISTRADOR:",
            dataAdmin
        );


        // =================================================
        // ADMINISTRADOR CORRECTO
        // =================================================

        if (
            respuestaAdmin.ok &&
            dataAdmin.ok === true
        ) {

            console.log(
                "LOGIN ADMINISTRADOR CORRECTO"
            );


            // =============================================
            // GUARDAR SESIÓN
            // =============================================

            if (
                dataAdmin.usuario
            ) {

                sessionStorage.setItem(
                    "usuarioSesion",
                    JSON.stringify(
                        dataAdmin.usuario
                    )
                );

            }


            // =============================================
            // MENSAJE
            // =============================================

            alert(
                "¡Bienvenido " +
                (
                    dataAdmin.usuario &&
                    dataAdmin.usuario.NOMBRE_USUARIO
                        ? dataAdmin.usuario.NOMBRE_USUARIO
                        : nombreUsuario
                ) +
                "!"
            );


            // =============================================
            // ADMINISTRADOR → MENÚ
            // =============================================

            window.location.href =
                "/menu.html";

            return;

        }


        // =================================================
        // =================================================
        // SEGUNDA VALIDACIÓN
        //
        // USUARIO NORMAL
        //
        // Ruta:
        // /inicio/iniciarSesionUsuarioNormal
        //
        // Procedimiento:
        // SP_INICIOSESIONUSUARIONORMAL
        //
        // Rol:
        // RRHH
        //
        // =================================================
        // =================================================

        console.log(
            "NO ES ADMINISTRADOR."
        );

        console.log(
            "VALIDANDO USUARIO NORMAL..."
        );


        const respuestaUsuario =
            await fetch(
                "/inicio/iniciarSesionUsuarioNormal",
                {

                    method: "POST",

                    headers: {

                        "Content-Type":
                            "application/json",

                        "Accept":
                            "application/json"

                    },

                    body:
                        JSON.stringify({

                            NOMBRE_USUARIO:
                                nombreUsuario,

                            PASSWORD:
                                contrasenia

                        })

                }
            );


        console.log(
            "ESTADO HTTP USUARIO NORMAL:",
            respuestaUsuario.status
        );


        // =================================================
        // LEER RESPUESTA USUARIO NORMAL
        // =================================================

        const dataUsuario =
            await respuestaUsuario.json();


        console.log(
            "RESPUESTA USUARIO NORMAL:",
            dataUsuario
        );


        // =================================================
        // USUARIO NORMAL CORRECTO
        // =================================================

        if (
            respuestaUsuario.ok &&
            dataUsuario.ok === true
        ) {

            console.log(
                "LOGIN USUARIO NORMAL CORRECTO"
            );


            // =============================================
            // GUARDAR SESIÓN
            // =============================================

            if (
                dataUsuario.usuario
            ) {

                sessionStorage.setItem(
                    "usuarioSesion",
                    JSON.stringify(
                        dataUsuario.usuario
                    )
                );

            }


            // =============================================
            // MENSAJE
            // =============================================

            alert(
                "¡Bienvenido " +
                (
                    dataUsuario.usuario &&
                    dataUsuario.usuario.NOMBRE_USUARIO
                        ? dataUsuario.usuario.NOMBRE_USUARIO
                        : nombreUsuario
                ) +
                "!"
            );


            // =============================================
            // USUARIO NORMAL → MENÚ
            // =============================================

            window.location.href =
                "/menu.html";

            return;

        }


        // =================================================
        // =================================================
        // TERCERA VALIDACIÓN
        //
        // OTROS USUARIOS
        //
        // Ruta:
        // /inicio/iniciarSesionOtrosUsuarios
        //
        // Procedimiento:
        // SP_INICIOSESIONOTROSUSUARIOS
        //
        // Roles:
        //
        // FINANZAS
        // PRODUCCION
        // LOGISTICA
        // MERCADEO
        //
        // =================================================
        // =================================================

        console.log(
            "NO ES USUARIO ADMINISTRADOR."
        );

        console.log(
            "NO ES USUARIO RRHH."
        );

        console.log(
            "VALIDANDO OTROS USUARIOS..."
        );


        const respuestaOtros =
            await fetch(
                "/inicio/iniciarSesionOtrosUsuarios",
                {

                    method: "POST",

                    headers: {

                        "Content-Type":
                            "application/json",

                        "Accept":
                            "application/json"

                    },

                    body:
                        JSON.stringify({

                            NOMBRE_USUARIO:
                                nombreUsuario,

                            PASSWORD:
                                contrasenia

                        })

                }
            );


        console.log(
            "ESTADO HTTP OTROS USUARIOS:",
            respuestaOtros.status
        );


        // =================================================
        // LEER RESPUESTA OTROS USUARIOS
        // =================================================

        const dataOtros =
            await respuestaOtros.json();


        console.log(
            "RESPUESTA OTROS USUARIOS:",
            dataOtros
        );


        // =================================================
        // OTROS USUARIOS CORRECTO
        // =================================================

        if (
            respuestaOtros.ok &&
            dataOtros.ok === true
        ) {

            console.log(
                "LOGIN OTROS USUARIOS CORRECTO"
            );


            // =============================================
            // MOSTRAR ROL OBTENIDO DESDE SQL
            // =============================================

            console.log(
                "ROL:",
                dataOtros.usuario
                    ? dataOtros.usuario.NOMBREROL
                    : "SIN ROL"
            );


            // =============================================
            // GUARDAR SESIÓN
            // =============================================

            if (
                dataOtros.usuario
            ) {

                sessionStorage.setItem(
                    "usuarioSesion",
                    JSON.stringify(
                        dataOtros.usuario
                    )
                );

            }


            // =============================================
            // MENSAJE
            // =============================================

            alert(
                "¡Bienvenido " +
                (
                    dataOtros.usuario &&
                    dataOtros.usuario.NOMBRE_USUARIO
                        ? dataOtros.usuario.NOMBRE_USUARIO
                        : nombreUsuario
                ) +
                "!"
            );


            // =============================================
            // OTROS USUARIOS → MISMO MENÚ
            // =============================================

            window.location.href =
                "/menu.html";

            return;

        }


        // =================================================
        // LOGIN INCORRECTO
        // =================================================

        alert(
            "Usuario, contraseña o rol incorrectos."
        );


    }

    catch (
        error
    ) {

        console.error(
            "ERROR LOGIN:",
            error
        );


        alert(
            "No se pudo conectar con el servidor."
        );

    }

    finally {

        btnIniciarSesion.disabled =
            false;

        btnIniciarSesion.innerHTML =
            '<i class="bi bi-box-arrow-in-right me-2"></i>' +
            'Iniciar sesión';

    }

}


// =====================================================
// BOTÓN
// =====================================================

if (
    btnIniciarSesion
) {

    btnIniciarSesion.addEventListener(
        "click",
        function (event) {

            event.preventDefault();

            iniciarSesion();

        }
    );

}


// =====================================================
// FORMULARIO
// =====================================================

if (
    formInicioSesion
) {

    formInicioSesion.addEventListener(
        "submit",
        function (event) {

            event.preventDefault();

            iniciarSesion();

        }
    );

}

